import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ISupervisorPermission } from "src/models/Maintenance/SupervisorPermission.models";

interface SupervisorPermissionState {
  supervisorPermissions: ISupervisorPermission[];
  supervisorPermissionToEdit: ISupervisorPermission | null;
}

const initialState: SupervisorPermissionState = {
  supervisorPermissions: [],
  supervisorPermissionToEdit: null,
};

const supervisorPermissionSlice = createSlice({
  name: "SupervisorPermission",
  initialState,
  reducers: {
    setSupervisorPermissionList: (state, action: PayloadAction<ISupervisorPermission[]>) => {
      state.supervisorPermissions = action.payload;
    },
    concatListSupervisorPermission: (state: SupervisorPermissionState, action: PayloadAction<ISupervisorPermission[]>) => {
      state.supervisorPermissions = [...state.supervisorPermissions.concat(action.payload)];
    },
    setSupervisorPermissionToEdit: (state, action: PayloadAction<ISupervisorPermission | null>) => {
      state.supervisorPermissionToEdit = action.payload;
    },
    addSupervisorPermission: (state, action: PayloadAction<ISupervisorPermission>) => {
      state.supervisorPermissions.push(action.payload);
    },
    updateSupervisorPermission: (state, action: PayloadAction<ISupervisorPermission>) => {
      let itemIndex = state.supervisorPermissions.findIndex(
        item => item.supervisorPermissionId === action.payload.supervisorPermissionId
      );
      if (itemIndex !== -1) state.supervisorPermissions[itemIndex] = action.payload;
    },
    deleteSupervisorPermission: (state, action: PayloadAction<number>) => {
      const newArray = state.supervisorPermissions.filter(
        item => item.supervisorPermissionId !== action.payload
      );
      state.supervisorPermissions = newArray;
    },
  },
});

export const {
  setSupervisorPermissionList,
  concatListSupervisorPermission,
  setSupervisorPermissionToEdit,
  addSupervisorPermission,
  updateSupervisorPermission,
  deleteSupervisorPermission,
} = supervisorPermissionSlice.actions;

export default supervisorPermissionSlice.reducer;
